<div class="container-fluid">
  <div class="buttontop btntop col-lg-11">
    <table>
      <tr>
        <td>
          <button class="btn border" (click)="searchInstitutions()">Sök</button>
        </td>
        <td style="padding: 10px;">
          <button class="btn border" (click)="clear()">Rensa</button>
        </td>
      </tr>
    </table>
  </div>
  <div *ngIf="countries" class="col-lg-11">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-6 ms-2">
        <form [formGroup]="form" (keyup.enter)="searchInstitutions();">
          <mat-expansion-panel class="accordionmargin" [expanded]=isExpanded>
            <mat-expansion-panel-header [expandedHeight]="'48px'">
              <mat-panel-title>
                Institution
                <p *ngIf="form.invalid" style="color: red;position:absolute;right:200px;">Kontrollera sökvillkoren</p>
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="form-group">
              <label for="institutionTypeId">Institutionstyp</label>
              <select #typ class="form-control form-control-sm" id="institutionTypeId" formControlName="institutionTypeId">
                <option></option>
                <option *ngFor="let inst of institutiontypes" [ngValue]="inst.id">{{inst.prefix}} - {{inst.name}}</option>
              </select>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="institutionNumber">
                  Institutionsnummer
                </label>
                <input type="text" class="form-control form-control-sm" id="institutionNumber" formControlName="institutionNumber">
              </div>
              <div class="form-group col-md-6">
                <label for="belongsTo">
                  Tillhör
                </label>
                <input type="text" class="form-control form-control-sm" id="belongsTo" formControlName="belongsTo">
              </div>
            </div>
            <div class="form-group">
              <label for="institutionName">
                Institutionsnamn
              </label>
              <input type="text" class="form-control form-control-sm" id="institutionName" formControlName="institutionName">
            </div>
            <div class="form-group">
              <label for="organizationNumber">
                Organisationsnummer
              </label>
              <input type="text" class="form-control form-control-sm" id="organizationNumber" formControlName="organizationNumber">
            </div>
            <div class="form-group">
              <label for="street">
                Gata
              </label>
              <input type="text" class="form-control form-control-sm" id="street" formControlName="street">
            </div>
            <div class="form-group">
              <label for="city">
                Ort
              </label>
              <input type="text" class="form-control form-control-sm" id="city" formControlName="city">
            </div>
            <div class="form-group">
              <label for="country">Land</label>
              <select class="form-control form-control-sm" id="country" formControlName="country">
                <option></option>
                <option *ngFor="let c of countries" [value]="c.name">{{c.name}}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="email">
                E-post
              </label>
              <input type="text" class="form-control form-control-sm" id="email" formControlName="email">
            </div>
            <div class="form-group">
              <label for="phone">
                Telefon
              </label>
              <input type="text" class="form-control form-control-sm" id="phone" formControlName="phone">
            </div>
            <div class="form-group">
              <label for="swish">
                Swish
              </label>
              <input type="text" class="form-control form-control-sm" id="swish" formControlName="swish">
            </div>
            <div class="form-group">
              <label for="phoneMobile">
                Mobil
              </label>
              <input type="text" class="form-control form-control-sm" id="phoneMobile" formControlName="phoneMobile">
            </div>
            <div class="form-group">
              <label for="webSite">
                Hemsida
              </label>
              <input type="text" class="form-control form-control-sm" id="webSite" formControlName="webSite">
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="bankAccount1">
                  Bankkonto 1
                </label>
                <input type="text" class="form-control form-control-sm" id="bankAccount1" formControlName="bankAccount1">
              </div>
              <div class="form-group col-md-6">
                <label for="bankAccount2">
                  Bankkonto 2
                </label>
                <input type="text" class="form-control form-control-sm" id="bankAccount2" formControlName="bankAccount2">
              </div>
            </div>
          </mat-expansion-panel>
        </form>
      </div>
      <div class="col-lg-8 col-md-7 col-sm-6 ms-2">
        <table *ngIf="institutions.length > 0" style="width: 200px;margin-bottom: 10px;">
          <tr>
            <td>
              Antal träffar: {{institutions.length}}
            </td>
          </tr>
        </table>
        <div *ngIf="institutions.length > 0" class="resultdiv">
          <table matSort (matSortChange)="sortData($event)" class="table table-bordered border" matSortDisableClear=true>
            <thead role="rowgroup">
              <tr>
                <th mat-sort-header="shortName">Kortnamn</th>
                <th mat-sort-header="name">Institutionsnamn</th>
                <th mat-sort-header="seat">Säte</th>
              </tr>
            </thead>
            <tr *ngFor="let inst of institutions;" class="trlink" title="Titta på institutionsdetaljer">
              <td>
                <a [routerLink]="['/institutions/id/', inst?.id]">{{inst.shortName}}</a>
              </td>
              <td>{{inst.name}}</td>
              <td>{{inst.seat}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="push"></div>
  </div>
  <div class="buttonbottom">
    <ng-template #childTemplate>
      <div class="col-lg-12">
        <div class="row">
          <table>
            <tr>
              <td>
                <div style="margin-top: 10px;margin-left:20px;">
                  <button class="btn border" (click)="clear()">Rensa</button>
                  <button class="btn border" (click)="searchInstitutions('search')" style="margin-left:20px;">Sök</button>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ng-template>

    <app-footer [childTemplate]="childTemplate"></app-footer>
  </div>